/*
 * Website: https://www.4myth.com
 * Email: mythpe@gmail.com
 * Mobile: +966590470092
 * Copyright © 2016-2022 All rights reserved.
 * MyTh Ahmed Fayez
 */

export default {
  name: 'حسابي',
  photo: 'صورة الملف الشخصي',
  accountInformation: 'بيانات الحساب',
  personalInformation: 'البيانات الشخصية',
  security: 'الأمان'
}
